import Plx from "../_modules/_Plx";

const AboutUs = () => {


  window.addEventListener('load',()=>{
    new Plx('aboutus',1);
  })
}

export default AboutUs;